<template>
  <div class="content contentA">
    <div class="box">
      <div class="box-title">
        <span style="font-size:16px;display:flex;"><el-page-header @back="$router.go(-1)">
</el-page-header>{{listName}}</span>
        <div>
          <div class="btn" style="font-size:16px" @click="add">添加</div>
        </div>
      </div>
      <div class="box-cont">
        <el-table
          height="72vh"
          :header-cell-style="{background:'#F5F7F9'}"
          border
          :data="treeData"
          style="width: 100%"
          row-key="value"
          border
          :tree-props="{children: 'child'}">
          <!-- <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                :show-header="false"
                :data="scope.row.chid"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="名称"
                  >
                </el-table-column>
                <el-table-column
                  
                  label="操作"
                  width="230">
                  <template slot-scope="scope">
              <div>
                <i  class="el-icon-edit"></i>
                <i class="el-icon-delete"></i>
                <i class="el-icon-folder-add"></i>
              </div>
            </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="label"
            label="名称">
          </el-table-column>
          <el-table-column
            label="操作"
            width="230">
            <template slot-scope="scope">
              <div class="shezhi">
                <el-button size="mini" type="primary" @click="edit(scope.row)" >编辑</el-button>
                <el-button size="mini" type="primary" @click="addChil(scope.row)" >添加</el-button>
                <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 弹出框 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog"
          width="600px"
          center>
          <p slot="title" class="dialog-title">新建父集文件夹</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="名称：">
              <el-input v-model="form.activeName" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm1">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 弹出框2 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog1"
          width="600px"
          center>
          <p slot="title" class="dialog-title">新建子集文件夹</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="所属项：">
              <el-input
                v-model="name"
                :disabled="true">
              </el-input>
            </el-form-item>
            <el-form-item label="名称：">
              <el-input v-model="form.activeName" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog1 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm2" >确 定</el-button>
          </span>
        </el-dialog>
        <!-- 弹出框3 -->
        <el-dialog
          class="dialog"
          :visible.sync="addDialog2"
          width="600px"
          center>
          <p slot="title" class="dialog-title">编辑</p>
          <el-form  label-position="right" label-width="180px">
            <el-form-item label="名称：">
              <el-input v-model="formqq.activeName" size="medium" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="addDialog2 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="submitForm3" >确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import base from '../../untils/base'
  import myHttp from '../../untils/port'
  import util from '../../untils/util'
  export default {
    data() {
      return {
        addDialog:false,
        addDialog1:false,
        addDialog2:false,
        list: [
          
        ],
        label:'',
        treeData:[],
        form:{
            dataType:'',
            activeName:'',
            parentId:'0',
            createBy:util.session.get('user').id,
            groupId:util.session.get('groupId')
          },
        formqq:{
            dataType:'',
            activeName:'',
            parentId:'0',
            createBy:util.session.get('user').id,
            groupId:util.session.get('groupId')
          },
        name:'',
        addForm1: {
          type: 'safe_check',
          label: '',
          parentId: 0,
          value:'2',
          projectId:util.session.get('groupId')
        },
        addForm2: {
          label: '',
          id:''
        },
        listName:''
      }
    },
    mounted(){
      this.listName = this.$route.query.name
      this.form.dataType = this.$route.query.dataType
      this.formqq.dataType = this.$route.query.dataType
      this.getTreeList()
    },
    methods:{
      del(item){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            myHttp.deleteByTreeId({
              id:item.value
            }).then(res=>{
              if(res.data.code){
                this.getTreeList()
                this.$message({
                  type: 'success',
                  message: `${res.data.msg}`
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })          
          })
      },
      addChil(item){
        this.name=item.label
        this.form.parentId = item.value
        this.form.activeName = ''
        this.addDialog1=true
      },
       add(){
        
        this.addDialog = true
      },
      submitForm1(){
        myHttp.createInfoDJ(this.form).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.form.parentId='0'
            this.form.activeName=''
            this.getTreeList()
            this.$message.success('添加成功！！')
            this.addDialog=false
          }else{
            this.$message({
              type:'warning',
              message:res.data.msg
            })
          }
        })
      },
      submitForm2(){
        myHttp.createInfoDJ(this.form).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.form.parentId=''
            this.form.activeName=''
            this.getTreeList()
            this.$message({
              type:'success',
              message:res.data.msg
            })
            this.addDialog1=false
          }else{
            this.$message({
              type:'warning',
              message:res.data.msg
            })
          }
        })
      },
      submitForm3(){
        
         myHttp.updateInfoSS(
          this.formqq
         ).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('修改成功！！')
            this.addDialog2 = false
            this.formqq.activeName = ''
        this.formqq.id = ''
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      edit(item){
        this.addDialog2 = true
        this.formqq.activeName = item.label
        this.formqq.id = item.value
        this.formqq.updateBy=util.session.get('user').id
        this.formqq.parentId=item.parentId
      },
      getTreeList(){
        let that = this
        myHttp.getPartyBuildingByGroupId({
          groupId:util.session.get('groupId'),
          dataType:this.$route.query.dataType
        }).then(res=>{
          if(res.data.code==200){
            that.treeData = res.data.data||[]
            // this.listItemId = that.list.child[0].value
            // that.currentNodekey = res.data.data[0].value
            // that.expandedkeys.push(res.data.data[0].value)
            // that.$nextTick(() => {
            //   // treeBox 元素的ref   value 绑定的node-key
            //   that.$refs.tree.setCurrentKey(that.currentNodekey)
            // })
          }
        })
      },
    }
  }
</script>

<style scoped>
.content{
  height: 100%;
  /* padding: 1vh 1vw; */
  display: flex;
  flex-direction: row;
  /* background-color: #fff; */
}
.el-form-item__label{
  text-align: right !important;
}
.contentA{
  padding: 15px 20px 15px 8px;
  
}
.box{
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.box-title{
  height: 4.8vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  border-bottom: 2px solid #eee;
}
.box-cont{
  flex: 1;
  padding: 0.5vw;
  padding-top:20px ;
}
.edit{
  color: #108c53;
  font-size: 14px;
}
.btn{
 width: 68px;
    height: 31px;
border-radius: 2px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
  justify-content: center;
  align-items: center;
}
.delete{
  color: #dd5a43;
  font-size: 14px;
}
.add{
  color: #1e5edb;
  font-size: 14px;
}
.edit:hover{
  opacity: 0.6;
  cursor: pointer;
}
.delete:hover{
  opacity: 0.6;
  cursor: pointer;
}
.add:hover{
  opacity: 0.6;
  cursor: pointer;
}
.shezhi{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 18%;
}
::v-deep .cell{
  text-align: start;
  font-size: 14px;
}
::v-deep .el-icon-arrow-right{
  font-size: 14px !important;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.6;
}
</style>